// extracted by mini-css-extract-plugin
module.exports = {"controls":"JYDml","playPauseBtn":"_3YrEU","forwardBtn":"_1zpBe","settingsBtn":"_232Nz"};